import { useMemo, useState } from 'react';
import { Select, SelectProps } from '@mantine/core';
import { useAgencyUsers } from '@/queries/users/useAgencyUsers';

export function UserSelector(props: Omit<SelectProps, 'data'>) {
  const [searchTerm, setSearchTerm] = useState('');
  const { data: usersData } = useAgencyUsers();

  const data = useMemo(
    () =>
      (usersData?.data ?? [])
        .filter(
          (user) =>
            !['client', 'system'].includes(user.role ?? '') &&
            (!user.archived || user.id === props.value) &&
            (!searchTerm || user.displayName?.toLowerCase().includes(searchTerm.toLowerCase()))
        )
        .map((user) => ({ label: user.displayName, value: user.id })),
    [usersData, searchTerm, props.value]
  );

  if (!data.length) {
    return null;
  }

  return (
    <Select
      data={data}
      searchable
      searchValue={searchTerm}
      onSearchChange={setSearchTerm}
      {...props}
    />
  );
}
